<template>
  <div>
    <div v-if="isTab2">
      <div
        class="result__card"
        :class="{
          'is-tab2': isTab2,
        }"
      >
        <div class="result__card-wrapper">
          <a
            class="profile-link utility-no-text-decoration"
            :href="'/find-a-therapist/' + supplierPage"
          >
            <h4>
              {{ supplierName }}
              <div class="result__card-arrow">
                <div class="icon icon-arrow-right-blue"></div>
              </div>
            </h4>
          </a>
          <div class="result__card-content-wrapper">
            <div v-if="supplierRegions" class="result__card-content-item">
              <p class="p-label result__card-label">Regions:</p>
              <div class="result__description-wrapper">
                <p>
                  {{ supplierRegions }}
                </p>
              </div>
            </div>
            <div class="result__contact-details-wrapper">
              <div v-if="supplierPhoneNumber" class="result__contact-method">
                <div class="icon icon-phone icon-phone-blue"></div>
                <a
                  :aria-label="'Phone number' + supplierPhoneNumber"
                  :href="'tel:' + supplierPhoneNumber"
                >
                  {{ supplierPhoneNumber }}
                </a>
              </div>
              <div v-if="supplierEmailAddress" class="result__contact-method">
                <div class="icon icon-email icon-email-blue"></div>
                <a
                  aria-label="Email address $SupplierContactEmail"
                  :href="'mailto:' + supplierEmailAddress"
                >
                  {{ supplierEmailAddress }}
                </a>
              </div>
              <div v-if="supplierWebsite" class="result__contact-method">
                <div class="icon icon-website icon-website-blue"></div>
                <a
                  :aria-label="'Website address: ' + supplierWebsiteText"
                  :href="supplierWebsite"
                >
                  {{ supplierWebsiteText }}
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <div
        class="result__card"
        :class="{
          'is-tab2': isTab2,
        }"
      >
        <div v-if="providerId">
          <a :href="'/find-a-therapist/' + providerId">
            <div class="result__card-wrapper">
              <h4>
                {{ firstName }} {{ surname }}
                <div class="result__card-arrow">
                  <div class="icon icon-arrow-right"></div>
                </div>
              </h4>
              <div class="result__card-content-wrapper">
                <div class="result__card-content-item">
                  <p class="p-label result__card-label">Regions:</p>
                  <div class="result__description-wrapper">
                    <p v-if="regions">{{ regions }}</p>
                    <p v-else>Not specified</p>
                  </div>
                </div>
                <div class="result__card-content-item">
                  <p class="p-label result__card-label">Gender:</p>
                  <p v-if="gender">{{ gender }}</p>
                  <p v-else>Not specified</p>
                </div>
                <div class="result__card-content-item">
                  <p class="p-label result__card-label">Spoken languages:</p>
                  <div class="result__description-wrapper">
                    <p v-if="languages">{{ languages }}</p>
                    <p v-else>Not specified</p>
                  </div>
                </div>
                <div class="result__card-content-item">
                  <p class="p-label result__card-label">Cultural expertise:</p>
                  <div class="result__description-wrapper">
                    <p v-if="culturalExperience">{{ culturalExperience }}</p>
                    <p v-else>Not specified</p>
                  </div>
                </div>
                <div class="result__card-content-item">
                  <p class="p-label result__card-label">Therapist expertise:</p>
                  <div class="result__description-wrapper">
                    <p v-if="therapistExperience">{{ therapistExperience }}</p>
                    <p v-else>Not specified</p>
                  </div>
                </div>
              </div>
            </div>
          </a>
        </div>
        <div v-else>
          <div class="result__card-wrapper">
            <h4>
              {{ firstName }} {{ surname }}
            </h4>
            <div class="result__card-content-wrapper">
              <div class="result__card-content-item">
                <p class="p-label result__card-label">Regions:</p>
                <div class="result__description-wrapper">
                  <p v-if="regions">{{ regions }}</p>
                  <p v-else>Not specified</p>
                </div>
              </div>
              <div class="result__card-content-item">
                <p class="p-label result__card-label">Gender:</p>
                <p v-if="gender">{{ gender }}</p>
                <p v-else>Not specified</p>
              </div>
              <div class="result__card-content-item">
                <p class="p-label result__card-label">Spoken languages:</p>
                <div class="result__description-wrapper">
                  <p v-if="languages">{{ languages }}</p>
                  <p v-else>Not specified</p>
                </div>
              </div>
              <div class="result__card-content-item">
                <p class="p-label result__card-label">Cultural expertise:</p>
                <div class="result__description-wrapper">
                  <p v-if="culturalExperience">{{ culturalExperience }}</p>
                  <p v-else>Not specified</p>
                </div>
              </div>
              <div class="result__card-content-item">
                <p class="p-label result__card-label">Therapist expertise:</p>
                <div class="result__description-wrapper">
                  <p v-if="therapistExperience">{{ therapistExperience }}</p>
                  <p v-else>Not specified</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Vue from "vue";

export default Vue.component("ResultCard", {
  props: {
    culturalExperience: String,
    email: String,
    firstName: String,
    gender: String,
    languages: String,
    providerId: String,
    isTab2: Boolean,
    name: String,
    regions: String,
    surname: String,
    telephone: String,
    therapistExperience: String,
    supplierId: String,
    supplierEmailAddress: String,
    supplierName: String,
    supplierPage: String,
    supplierPhoneNumber: String,
    supplierRegions: String,
    supplierURLPhoneNumber: String,
    supplierWebsite: String,
    supplierWebsiteText: String,
  },
});
</script>
